import React from "react";
import "../styles/blog1.css";

import { useState } from "react";
import { Link } from "react-router-dom";

const Blog1 = () => {
  const [hover, setHover] = useState(false);

  return (
    <main
      className="main-section"
      style={{ maxWidth: 1200, margin: "120px auto 40px auto", padding: 30 }}
    >
      <Link
        to="/blogs"
        style={{
          background: hover ? "#f96e2a" : "#fff",
          border: "1.5px solid #f96e2a",
          borderRadius: 20,
          padding: "7px 22px",
          color: hover ? "#fff" : "#f96e2a",
          fontWeight: 500,
          marginBottom: 28,
          cursor: "pointer",
          boxShadow: "0 2px 14px #f7c69c15",
          textDecoration: "none",
          display: "inline-block",
          transition: "all 0.18s",
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        ← Back to Blogs
      </Link>
      <section className="blog-article">
        <div className="blog-article-header">
        <img
            className="blog-author-photo"
            src={require("../assets/blogs/ceo.webp")}
            alt="Abhishek Bhatia, CFA"
          />
          <div className="blog-author-info">
            <span className="blog-author-name">Abhishek Bhatia, CFA</span>
            <span className="blog-author-role">CEO & Partner Serenityy</span>
          </div>
        </div>
        <h2 className="blog-article-title">
          Why Having an Alternative Source of Income Is No Longer Optional.{" "}
        </h2>
        <p style={{ fontSize: "0.95rem", opacity: 0.7 }}>
          Posted on 4 July 2025
        </p>
        <p>
          In the era of rising living costs, inflation, and global instability,
          having numerous streams of steady income is no longer a luxury, but a
          need.
          <br />
          <br /> At Serenityy, we work closely with individuals, families, and
          enterprises to help them develop strong, diverse financial
          foundations, and one of the most important things we offer is to
          create an alternative stream of income.
          <br />
          <br /> Having multiple sustainable and reliable sources of income
          stream not only provide the additional liquidity but caters to a more
          lasting and pressing issues of uncertainties. You work hard for your
          money; wouldn't it be wise to let your money work for you so that you
          can have peace of mind?
          <br />
          <br /> The article covers the following factors emphasizing why having
          an alternate source of income is no longer an option.
        </p>
        <h3>Here is why.</h3>
        <ul>
          <li>
            <b>Protect yourself from uncertainties</b>
            <p>
              First, the pandemic brought the world to a halt, taught us that no
              career or revenue stream is guaranteed. With the shifting
              landscape of the global economy and even our lifestyle choices and
              preferences, growing dependence on AI, and the impact geopolitical
              issues is our primary stream of income secured.
              <br />
              <br /> We should ask and seek answers to the following questions:
              <br /> <br />
              What if… your job is affected by market changes?
              <br /> What if… your business slows down unexpectedly?
              <br />
              <br /> Having an alternate source of income, whether from
              investments, property rentals, or side businesses, gives you a
              safety net during uncertain times.
            </p>
          </li>
          <li>
            <b>Increase your financial freedom</b>
            <p>
              Multiple revenue streams offer options. More choices. More control
              over your lifestyle. <br />
              <br /> Want to start your own business someday?
              <br /> Want to retire earlier or travel more?
              <br /> Do you want to secure your children's future?
              <br />
              <br />
              Building passive, sustainable, and secure active income helps you
              get closer to your goals faster.
            </p>
          </li>
          <li>
            <b>Beat Inflation and Rising Costs </b>
            <p>
              Even if you are doing well today, inflation gradually reduces your
              purchasing power each year.
              <br />
              <br /> Real estate rental income.
              <br /> Dividends from investments.
              <br /> Side businesses or online ventures
              <br />
              <br /> These income streams help you stay ahead of rising
              expenditures and maintain your financial stability.
            </p>
          </li>
          <li>
            <b>Build Wealth, not only Earn Money</b>
            <p>
              Earning a salary or a profit from your business is nice, but it is
              still work for money.
              <br />
              Alternate income sources, such as investments, allow you to put
              your money to work. That is how you create long-term wealth, not
              just short-term revenue.
            </p>
          </li>
          <li>
            <b>Peace of mind</b>
            <p>
              Perhaps the most significant advantage of alternate income is
              peace of mind.
              <br />
              Knowing that you have more than one financial safety net provides
              you confidence in your future, regardless of what life throws at
              you.
            </p>
          </li>
        </ul>
        <h2 style={{ fontSize: "1.5rem" }}>
          <br />
          How to Start Building Alternate Income?
        </h2>
        <p style={{ fontSize: "1.12em" }}>
          <strong>Serenityy</strong> helps people develop other income through:
        </p>
        <ul>
          <li>Investment Planning (Local &amp; Global markets)</li>
          <li>Real Estate Advisory (Rental Properties in Dubai)</li>
          <li>Insurance with Investment Benefits</li>
          <li>Business Setup Guidance for side projects</li>
        </ul>
        <p style={{ fontSize: "0.95em" }}>
          <br />
          Regardless of your current income or history, there are strategies to
          develop your wealth safely, smartly, and effectively.
          <br />
          Want to start building alternate income streams but not sure where to
          begin? <strong>Let’s talk.</strong>
        </p>
      </section>
    </main>
  );
};

export default Blog1;
